module.exports = __webpack_public_path__ + "img/A5.ba7050fe.svg";